import { render, staticRenderFns } from "./PromotionCoursesTable.vue?vue&type=template&id=5bb0b931"
import script from "./PromotionCoursesTable.vue?vue&type=script&lang=js"
export * from "./PromotionCoursesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports